import { render, staticRenderFns, recyclableRender, components } from "./all-orders.vue?vue&type=template&id=32952ab4&scoped=true&"
var renderjs
import script from "./all-orders.vue?vue&type=script&lang=js&"
export * from "./all-orders.vue?vue&type=script&lang=js&"
import style0 from "./all-orders.vue?vue&type=style&index=0&id=32952ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32952ab4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/all-orders/all-orders.vue"
export default component.exports